import { gql } from "@apollo/client";

export const IMPORT_DEFAULT_ZIPCODE_PICKUP_HUB_CONFIG = gql`
    mutation ImportDefaultZipcodePickupHubConfig($input: ImportDefaultZipcodePickupHubConfigInput!) {
        importDefaultZipcodePickupHubConfig(input: $input) {
            success
            message
            totalCount
            importedCount
            failedCount
        }
    }
`;

export interface ImportDefaultZipcodePickupHubConfigInput {
    objectKey: string;
    filename: string;
}

export interface ImportDefaultZipcodePickupHubConfigResponse {
    importDefaultZipcodePickupHubConfig: {
        success: boolean;
        message: string;
        totalCount: number;
        importedCount: number;
        failedCount: number;
    };
}

export interface ImportDefaultZipcodePickupHubConfigVariables {
    input: ImportDefaultZipcodePickupHubConfigInput;
}
